import React, { useRef, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useParams, useNavigate } from 'react-router-dom';
import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import toastService from '../services/toastService';
import { useAuth } from '../context/AuthContext';
import { useDropzone } from 'react-dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarChart, faFileImport, faFileInvoice, faFileUpload, faGear, faGlobe, faGlobeOceania, faHeadset, faHexagonNodes, faPlus, faSearch, faTableColumns, faUser, faCheck, faTimes, faChevronCircleLeft, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { faEdit, faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import { listFiles, uploadFile } from '../services/fileUploadService';
import { getKnowledgeBaseByPagination } from '../services/knowledgeBaseService';
import { getAllConnectorsByFilter } from '../services/connectorService';
// import { getDataSources, updateDataSource, createDataSource } from '../services/dataSourceService';
import { createChatForKb, createMessageForChat, getAllChatsByFilter, getAllMessagesByFilter, getDocMetaDataWithFilters, ingestFilesToKnowledgebase, streamKnowledgeBaseQuery, summarizeConversationForKb, updateChatForKb } from '../services/kbQueryService';
import { v4 as uuidv4 } from 'uuid';
import {
  PageContainer,
  PageHeader,
  PageTitle,
  PageIcon,
  PageDescription,
  ContentGrid,
  ContentRow,
  Card,
  CardTitle,
  CardContent,
  ListItemTime,
  Button,
  Input,
  SearchInput,
  ListItemStatus,
  FloatingCard,
  AgentHeader,
  AgentAvatar,
  AgentInfo,
  AgentName,
  AgentType,
  List,
  ListItem,
  ListItemIcon,
  Table,
  ChatButtons,
  ListItemContent,
  ListItemTitle,
  ListItemDescription,
  formatDate,
  formatBytes,
  fadeIn,
  ListItemMeta,
  FlexLayout,
  Flex1ThirdLayout,
  Flex2ThirdLayout,
  SubSectionTitle,
  StrongOrbi,
  Divider,
  TableCell,
  FormRowFull,
  CollapsibleSidebar,
  ChatInput,
  ChatWrapper,
  ChatScrollContainer,
  ChatUserCard,
  ChatSystemCard,
  ChatBottom,
  useGoBack,
  TableHeader,
  TableRow,
  StatusBadge,
  QueryBadge,
  TooltipWrapper,
  Tooltip,
  MarkdownContainer
} from '../styles/PageStyles';

// Add CSS for the slideUp animation
const slideUpKeyframes = `
@keyframes slideUp {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
`;

// Create a style element and append it to the document head
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.appendChild(document.createTextNode(slideUpKeyframes));
  document.head.appendChild(style);
}

const KnowledgeBaseQuery = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { knowledgebaseId } = useParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [knowledgeBaseDetail, setKnowledgebaseDetail] = useState();
  const [connector, setConnector] = useState();
  // const [dataSource, setDataSource] = useState([]);
  const [files, setFiles] = useState([]);
  const [fileCount, setFileCount] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [chatMode, setChatMode] = useState(null);
  const [sideBarCollapsed, setSideBarCollapsed] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [messageList, setMessageList] = useState(null);
  const [chatList, setChatList] = useState([]);
  const [maxFiles, setMaxFiles] = useState(10);
  const [maxSize, setMaxSize] = useState(10 * 1024 * 1024); // 10 MB
  const [fileTypes, setFileTypes] = useState({
    'application/pdf': ['.pdf'],
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
  });
  const [transcribedText, setTranscribedText] = useState('');
  const [queryContext, setQueryContext] = useState('query');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchModalTerm, setSearchModalTerm] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  // For the documents uploaded for this KB
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [documentList, setDocumentList] = useState([]);
  const [polling, setPolling] = useState(false);
  const [showAttachmentPanel, setShowAttachmentPanel] = useState(false);


  const chatContainerRef = useRef(null);
  const textareaRef = useRef(null);
  const textareaRef2 = useRef(null);
  const streamingAnswerRef = useRef('');
  const streamingMessageCodeRef = useRef(null);
  const hasAutoSelectedChatRef = useRef(false);
  const [kbUserId] = useState(() => uuidv4());

  // // For COnnector corresponding to DS
  // useEffect(() => {
  //   const fetchConnectors = async () => {
  //     try {
  //       let filter = {}
  //       const response = await getAllConnectorsByFilter(filter, {});
  //       setConnector(response || []);
  //     } catch (error) {
  //       console.error('Error fetching users:', error);
  //     }
  //   };
  //   fetchConnectors();
  // }, [user]);

  // For KNowledgeBase Current - only runs once when component mounts or when knowledgebaseId changes
  useEffect(() => {
    const fetchKnowledgebaseByCode = async () => {
      try {
        const parsedKnowledgebaseId = (knowledgebaseId);

        const filter = { "code": parsedKnowledgebaseId };
        const sort = {};
        const query = {};
        // console.log("Fetching knowledge base data...");
        const response = await getKnowledgeBaseByPagination(filter, sort , query );
        setKnowledgebaseDetail({
          ...response[0],
          pii_flag: response[0]?.pii_flag ?? false,
        });

      } catch (error) {
        console.error('Error fetching knowledge base:', error);
      }
    };
    if (knowledgebaseId) {
      fetchKnowledgebaseByCode();
    } else {
      navigate(`/knowledge-base/${knowledgebaseId}`);
    }
    // Only re-run if knowledgebaseId changes, not on every user change
  }, [knowledgebaseId, navigate]);

  // Define fetchFiles with useCallback, using stable kbCode parameter instead of the whole object
  const fetchFiles = React.useCallback(async (kbCode) => {
    try {
      if (kbCode) {
        console.log("Fetching files for knowledge base...");
        // Call API to fetch files using the knowledgeBaseDetail code
        const response = await listFiles(kbCode);
        setUploadedFiles(response || []);
        setFileCount(response.length)
      }
    } catch (error) {
      console.error('Error fetching files:', error);
    }
  }, []); // No dependencies since we're passing kbCode as a parameter

  // Files OF KB - runs only when knowledgeBaseDetail.code changes or fileCount is updated
  useEffect(() => {
    if (knowledgeBaseDetail?.code) {
      fetchFiles(knowledgeBaseDetail.code);
    }
  }, [fetchFiles, knowledgeBaseDetail?.code, fileCount]); // Only depend on the code property and fileCount
  const fetchDocumentList = async () => {
    try {
      const response = await getDocMetaDataWithFilters({ knowledge_base: knowledgeBaseDetail.code });
      setDocumentList(response || []);
      fetchFiles();
      pollDocumentStatus();
    } catch (error) {
      console.error('Error fetching document list:', error);
    }
  };
  const pollDocumentStatus = async (flag = false) => {
    setPolling(flag);
    try {
      let allCompleted = false;
      while (!allCompleted) {
        const response = await getDocMetaDataWithFilters({ knowledge_base: knowledgeBaseDetail.code });
        setDocumentList(response || []);
        allCompleted = response.every(
          (doc) => doc.processing_status === 'COMPLETED' || doc.processing_status === 'ERROR'
        );
        if (!allCompleted) {
          await new Promise((resolve) => setTimeout(resolve, 10000)); // Poll every 5 seconds
        }
      }
    } catch (error) {
      console.error('Error polling document status:', error);
    } finally {
      setPolling(false);
    }
  };
  // For Datasource
  // useEffect(() => {
  //   const fetchDataSourcesWithConnectors = async () => {
  //     try {
  //       if (Array.isArray(knowledgeBaseDetail?.data_source) && knowledgeBaseDetail.data_source.length > 0) {
  //         const dataSourceResponses = await Promise.all(
  //           knowledgeBaseDetail.data_source.map((dataSourceName) => {
  //             const filter = { code: dataSourceName, status: 'ACTIVE' };
  //             return getDataSources(filter, {});
  //           })
  //         );

  //         // Extract the first record from each data source response
  //         const fetchedDataSources = dataSourceResponses.map((response) => response[0]).filter(Boolean);

  //         // Fetch connectors for each data source and add connector details
  //         const updatedDataSources = await Promise.all(
  //           fetchedDataSources.map(async (ds) => {
  //             const connectorResponse = connector.filter((conn) => conn.code === ds.connector);
  //             const connectorDetails = connectorResponse[0] ?? []; // Get the first connector
  //             return { ...ds, connectorDetails }; // Add connector details to the data source
  //           })
  //         );

  //         // Update the dataSource state with the enriched data sources
  //         setDataSource(updatedDataSources);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching data sources or connectors:', error);
  //     }
  //   };

  //   fetchDataSourcesWithConnectors();
  // }, [knowledgeBaseDetail?.data_source, connector]);

  // Chats - define fetchChats with useCallback for better performance
  const fetchChats = React.useCallback(async (kbCode) => {
    try {
      if (kbCode) {
        console.log("Fetching chats for knowledge base...");
        let filter = {
          kb: kbCode
        }
        // Call API to fetch chats using the code
        const response = await getAllChatsByFilter(filter);
        if (response && response.length > 0) {
          setChatList(response || []);
        } else {
          setSideBarCollapsed(true)
        }
      }
    } catch (error) {
      console.error('Error fetching chats:', error);
    }
  }, []);

  useEffect(() => {
    if (knowledgeBaseDetail?.code) {
      fetchChats(knowledgeBaseDetail.code);
    }
  }, [knowledgeBaseDetail?.code, fetchChats]); 

  // Auto-select and load the most recent conversation when chats are available
  useEffect(() => {
    if (hasAutoSelectedChatRef.current) return;
    if (!knowledgeBaseDetail?.code) return;
    if (!Array.isArray(chatList) || chatList.length === 0) return;

    // If a chat is already selected (e.g., via navigation), respect it and mark as handled
    if (selectedChat && selectedChat.code) {
      hasAutoSelectedChatRef.current = true;
      return;
    }

    // Pick the most recent conversation by created_at, falling back to first item
    let defaultChat = chatList[0];
    if (chatList.length > 1) {
      defaultChat = [...chatList].sort((a, b) => {
        const aDate = a.created_at ? new Date(a.created_at) : 0;
        const bDate = b.created_at ? new Date(b.created_at) : 0;
        return bDate - aDate;
      })[0];
    }

    if (defaultChat) {
      hasAutoSelectedChatRef.current = true;
      // Fire and forget; handleSelectedChat manages its own async work
      handleSelectedChat(defaultChat);
    }
  }, [chatList, knowledgeBaseDetail?.code, selectedChat]);


  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messageList]); 
  
  const adjustTextareaHeight = (element) => {
    if (!element) return;
    
    element.style.height = 'auto';
    
    const newHeight = Math.min(element.scrollHeight, 50); // Max height
    element.style.height = `${newHeight}px`;
    
    element.style.overflowY = element.scrollHeight > 50 ? 'auto' : 'hidden';
  };
  
  // Adjust height when text changes
  useEffect(() => {
    if (textareaRef.current) {
      adjustTextareaHeight(textareaRef.current);
    }
    if (textareaRef2.current) {
      adjustTextareaHeight(textareaRef2.current);
    }
  }, [transcribedText]);


  // Add new state for uploaded files with additional metadata
  const [uploadedFileDetails, setUploadedFileDetails] = useState([]);

  // File Upload
  const onDrop = async (acceptedFiles, rejectedFiles) => {
    // Handle rejected files
    if (rejectedFiles.length > 0) {
      rejectedFiles.forEach((file) => {
        if (file.errors.some((err) => err.code === 'file-too-large')) {
          toastService.error(`File "${file.file.name}" exceeds the maximum size of ${maxSize / (1024 * 1024)} MB.`);
        }
        if (file.errors.some((err) => err.code === 'file-invalid-type')) {
          const allowedTypes = Object.keys(fileTypes).map(type => type.split('/')[1]).join(', ');
          toastService.error(`File "${file.file.name}" is not an allowed type. Allowed types: ${allowedTypes}`);
        }
      });
    }

    // No accepted files
    if (acceptedFiles.length === 0) {
      return;
    }

    // Check if knowledge base details are available
    if (!knowledgeBaseDetail || !knowledgeBaseDetail.code) {
      toastService.error("Knowledge base information is missing. Please reload the page.");
      return;
    }

    // Check if adding new files exceeds the maxFiles limit
    if (uploadedFileDetails.length + acceptedFiles.length > maxFiles) {
      toastService.error(`You can only upload up to ${maxFiles} files.`);
      return;
    }

    try {
      // Show loading toast
      toastService.info(`Uploading ${acceptedFiles.length} files...`);
      
      // Upload each file but don't ingest yet
      const newUploadedFiles = [];
      for (const file of acceptedFiles) {
        try {
          const uploadResponse = await handleUpload(file);
          if (uploadResponse && uploadResponse.data && uploadResponse.data.url) {
            newUploadedFiles.push({
              url: uploadResponse.data.url,
              name: file.name,
              size: file.size,
              type: file.type
            });
            toastService.success(`File "${file.name}" uploaded successfully`);
          } else {
            toastService.error(`Failed to upload file "${file.name}". Response format incorrect.`);
            console.error('Upload response format incorrect:', uploadResponse);
          }
        } catch (error) {
          toastService.error(`Failed to upload file "${file.name}": ${error.message || "Unknown error"}`);
          console.error(`Error uploading file ${file.name}:`, error);
        }
      }
      
      if (newUploadedFiles.length > 0) {
        // Update the files state with detailed information
        setUploadedFileDetails(prevFiles => [...prevFiles, ...newUploadedFiles]);
        
        // Set chat mode
        setChatMode('chat');
      } else {
        toastService.error("No files were successfully uploaded.");
      }
    } catch (error) {
      console.error('Error in file upload process:', error);
      toastService.error(`Error uploading files: ${error.message || "Unknown error"}`);
    }
  };

  // Function to handle the ingestion process
  const handleIngestFiles = async () => {
    if (uploadedFileDetails.length === 0) {
      // If no files are uploaded, check if there's text before submitting
      if (transcribedText.trim()) {
        handleSubmitQuery();
      }
      return;
    }

    try {
      // Extract just the URLs for ingestion
      const fileUrls = {};
      uploadedFileDetails.forEach(file => {
        if (file.url) {
          fileUrls[file.url] = [];
        }
      });
      if (!Object.keys(fileUrls).length) {
        toastService.error("Some file URLs are missing. Please try uploading again.");
        return;
      }
      
      // Get the file names for display in toast messages
      const fileNames = uploadedFileDetails.map(file => file.name).join(", ");
      toastService.info(`Processing files: ${fileNames}`);
      
      // If we have a selected chat, we could update it with file information
      // This is commented out since we're not using it currently but keeping for future reference
      /*
      const fileList = uploadedFileDetails.map(file => file.name).join(", ");
      const updatedChat = {
        ...selectedChat,
        context: 'document',
        title: `${fileList}: ${new Date().toLocaleString()}`,
        document_list: fileUrls,
        coversations: [
          {
            conv_title: `Uploaded File(s): ${fileList}`,
            source: 'user',
            created_at: new Date().toISOString()
          }, {
            conv_title: `Ingestion Started`,
            source: 'system',
            created_at: new Date().toISOString()
          }
        ]
      };
      */
      
      // Show loading toast
      toastService.info(`Starting ingestion of ${Object.keys(fileUrls).length} files...`);

      // Ingest files to knowledge base (new KB ingestion API)
      const ingestResponse = await ingestFilesToKnowledgebase(
        knowledgeBaseDetail.code,
        fileUrls
      );
      
      if (ingestResponse) {
        let tmp = fileCount + 1;
        setFileCount(tmp);
        toastService.success(`Files ingested successfully!`);
        pollDocumentStatus(true);
        
        // Clear the uploaded files after ingestion
        setUploadedFileDetails([]);
        
        // Also process any query text if it exists
        if (transcribedText.trim()) {
          handleSubmitQuery();
        }
      } else {
        toastService.error("Failed to ingest files. Please try again.");
      }
    } catch (error) {
      console.error('Error ingesting files:', error);
      toastService.error(`Error ingesting files: ${error.message || "Unknown error"}`);
    }
  };

  // This function is currently not used but kept for potential future use
  /* 
  const setChatContextandUpdateList = () => {
    // Update selectedChat
    const updatedChat = {
      ...selectedChat,
      context: 'chat',
    };

    // Update chatList with the updated selectedChat
    const updatedChatList = chatList.map((chat) =>
      chat.code === updatedChat.code ? updatedChat : chat
    );

    // Update state
    setSelectedChat(updatedChat);
    setChatList(updatedChatList);
    setChatMode('chat')
  };
  */

  const handleUpload = async (file) => {
    if (file) {
      try {
        const response = await uploadFile(file, knowledgeBaseDetail.code, 'adhoc', new Date().getTime());
        return response;
      } catch (error) {
        console.error('Error uploading file:', error);
        toastService.error(`Error uploading file: ${error.message}`);
      }
    }
  };
  
  // Function to remove a file from the uploaded files list
  const removeFile = (fileUrl) => {
    setUploadedFileDetails(prevFiles => prevFiles.filter(file => file.url !== fileUrl));
  };
  const handleVoiceRecording = () => {
    // Check if the browser supports SpeechRecognition
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      toastService.error('Your browser does not support voice recognition. Please use a supported browser like Chrome or Edge.');
      return;
    }

    const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
    recognition.lang = 'en-US';
    recognition.onresult = (event) => console.log(event.results[0][0].transcript);
    recognition.onerror = (event) => console.error('Error:', event.error);
    recognition.interimResults = false; // Only return final results
    recognition.maxAlternatives = 1;

    // Start recording
    recognition.start();

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setTranscribedText(transcript);
      console.log(transcript)
      // handleSubmitQuery();
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error:', event.error);
      switch (event.error) {
        case 'not-allowed':
          toastService.error('Microphone access is blocked. Please allow microphone access in your browser settings.');
          break;
        case 'network':
          toastService.error('Network error occurred. Please check your internet connection.');
          break;
        case 'service-not-allowed':
          toastService.error('Speech recognition service is not allowed. Please check your browser settings.');
          break;
        case 'aborted':
          toastService.error('Speech recognition was aborted. Please try again.');
          break;
        case 'audio-capture':
          toastService.error('No microphone was found. Please ensure your microphone is connected and try again.');
          break;
        default:
          toastService.error('An error occurred during voice recognition. Please try again.');
      }
    };

    recognition.onend = () => {
      console.log('Voice recording ended.');
    };
  };
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles,
    maxSize,
    accept: fileTypes,
  });
  const handleSelectedChat = async (chat) => {
    // For v2, we keep message rendering purely from local state.
    // Persisted messages are still written via /mms_persistence/message
    // but are not re-fetched for display here to avoid duplicates.
    setSelectedChat(chat);

    const filter = {
      kb: knowledgeBaseDetail.code,
      conversation: chat.code,
    };

    try {
      const response = await getAllMessagesByFilter(filter, { created_at: 'asc' });
      setMessageList(response || []);
    } catch (error) {
      console.error('Error fetching messages for selected chat:', error);
      setMessageList([]);
    }

    setChatMode('chat');
  };

  const handleSubmitQuery = async () => {
    setChatMode('chat');
    setIsTyping(true);
    let tmpSelectedChat = selectedChat ?? {};
    // If no selectedChat, create a new conversation
    if (!selectedChat) {
      let tmpChat = {
        title: "Temporary Chat",
        company_cd: user.companyCd,
        context: null,
        document_list: [],
        kb: knowledgeBaseDetail.code,
        coversations: [],
        code: "CH-" + new Date().getTime(),
        ingestion_status: null,
        is_selected: false,
        created_at: new Date().toISOString()
      };
      tmpSelectedChat = (tmpChat)
      try {
        // Call API to create a new conversation
        const newChatResponse = await createChatForKb(tmpChat);

        if (newChatResponse) {
          tmpSelectedChat = (newChatResponse)
          setSelectedChat(newChatResponse); // Use the response to set selectedChat
          // tmpTyped.conversation = newChatResponse.conversation_id; // Update conversation code in the message
        }
      } catch (error) {
        console.error("Error creating new chat:", error);
        setIsTyping(false);
        return; // Exit if chat creation fails
      }
    }

    // Add the currently typed message in the MessageList
    const timestamp = new Date().getTime();
    let tmpTyped = {
      kb: knowledgeBaseDetail.code,
      to: "agent",
      code: "MSG" + timestamp,
      from: user.username,
      message: transcribedText,
      company_cd: user.companyCd,
      conversation: tmpSelectedChat?.code || null, // Use selectedChat if available
      created_at: new Date().toISOString(),
    };

    setMessageList((prevMessageList) => [...(prevMessageList || []), tmpTyped]);
    setTranscribedText("");
    // Send message to chat service
    createMessageForChat(tmpTyped)
      .catch(error => console.error("Failed to save message:", error));
    // Scroll to the bottom of the chat container
    setTimeout(() => {
      const chatContainer = document.querySelector(".ChatScrollContainer");
      if (chatContainer) {
        chatContainer.scrollTop = chatContainer.scrollHeight;
      }
    }, 100);

    // Prepare streaming placeholders
    streamingAnswerRef.current = '';
    const agentMessageCode = "MSG" + timestamp + "-agent";
    streamingMessageCodeRef.current = agentMessageCode;

    const streamingMessage = {
      kb: knowledgeBaseDetail.code,
      to: user.username,
      code: agentMessageCode,
      from: "agent",
      message: '',
      company_cd: user.companyCd,
      conversation: tmpSelectedChat?.code || tmpTyped.conversation,
      created_at: new Date().toISOString(),
      is_streaming: true
    };

    setMessageList((prevMessageList) => [...(prevMessageList || []), streamingMessage]);

    const handleStreamingMessage = (obj) => {
      if (!obj) return;

      if (obj.type === 'final_response' || obj.type === 'partial_response') {
        const content = obj.content || '';
        streamingAnswerRef.current = (streamingAnswerRef.current || '') + content;
        const code = streamingMessageCodeRef.current;
        if (!code) return;
        setMessageList((prev) => {
          if (!prev) return prev;
          return prev.map((msg) =>
            msg.code === code && msg.from === 'agent'
              ? { ...msg, message: streamingAnswerRef.current }
              : msg
          );
        });
      }

      if (obj.type === 'stream_done') {
        const finalContent = streamingAnswerRef.current || '';
        const code = streamingMessageCodeRef.current;
        setIsTyping(false);

        if (finalContent && code) {
          const finalMessage = {
            kb: knowledgeBaseDetail.code,
            to: user.username,
            code: code,
            from: 'agent',
            message: finalContent,
            company_cd: user.companyCd,
            conversation: tmpSelectedChat?.code || tmpTyped.conversation,
            created_at: new Date().toISOString(),
          };

          createMessageForChat(finalMessage)
            .catch(error => console.error('Failed to save streamed response message:', error));

          setMessageList((prev) => {
            if (!prev) return prev;
            return prev.map((msg) =>
              msg.code === code && msg.from === 'agent'
                ? { ...finalMessage, is_streaming: false }
                : msg
            );
          });

          // After the streamed answer is finalized, summarize the conversation
          // and update the conversation title/context. This is best-effort and
          // should never break the chat flow.
          (async () => {
            try {
              const summary = await summarizeConversationForKb({
                knowledge_base_cd: knowledgeBaseDetail.code,
                session_id: tmpSelectedChat?.code,
                user_id: kbUserId,
              });

              if (!summary || (!summary.title && !summary.context)) {
                return;
              }

              const baseChat = tmpSelectedChat && tmpSelectedChat.code
                ? tmpSelectedChat
                : selectedChat;

              if (!baseChat || !baseChat.code) {
                return;
              }

              const updatedChatPayload = {
                ...baseChat,
                title: summary.title || baseChat.title,
                context: summary.context || baseChat.context,
                updated_at: new Date().toISOString(),
              };

              const savedChat = await updateChatForKb(updatedChatPayload);

              // Update selectedChat and chatList locally
              if (savedChat && savedChat.code) {
                setSelectedChat(savedChat);
                setChatList((prevChats) => {
                  if (!Array.isArray(prevChats)) return prevChats;
                  return prevChats.map((chat) =>
                    chat.code === savedChat.code ? savedChat : chat
                  );
                });
              }
            } catch (err) {
              // Silent failure by design; log only for debugging.
              console.error('Failed to summarize or update KB conversation:', err);
            }
          })();
        } else {
          // Mark streaming as finished even if no content
          setMessageList((prev) => {
            if (!prev) return prev;
            return prev.map((msg) =>
              msg.code === streamingMessageCodeRef.current && msg.from === 'agent'
                ? { ...msg, is_streaming: false }
                : msg
            );
          });
        }
      }
    };

    try {
      await streamKnowledgeBaseQuery({
        query: tmpTyped.message,
        session_id: tmpSelectedChat?.code,
        user_id: kbUserId,
        knowledge_base_cd: knowledgeBaseDetail.code,
        system_prompt: 'You are helpful assistant',
        payload: {}
      }, handleStreamingMessage);
    } catch (error) {
      console.error('Error streaming knowledge base query:', error);
      setIsTyping(false);
      // Optionally annotate the streaming message with an error
      const code = streamingMessageCodeRef.current;
      setMessageList((prev) => {
        if (!prev || !code) return prev;
        return prev.map((msg) =>
          msg.code === code && msg.from === 'agent'
            ? { ...msg, message: 'Sorry, there was an error processing your request.', is_streaming: false }
            : msg
        );
      });
    }
  };


  const chatDateFormat = (dateValue) => {
    if (!dateValue) return '';
    
    let date;
    if (dateValue instanceof Date) {
      date = new Date(dateValue);
    } else {
      // Handle UTC dates that don't have the Z suffix or timezone info
      if (typeof dateValue === 'string' && !dateValue.endsWith('Z') && !dateValue.includes('+')) {
        const utcDate = new Date(dateValue + 'Z');
        date = utcDate;
      } else {
        date = new Date(dateValue);
      }
    }
    
    // Format time in the local timezone
    const time = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).format(date);

    // Format date in the local timezone
    const day = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
    }).format(date);

    return `${time} | ${day}`;
  };

const groupConversationsByDate = (conversations) => {
  const grouped = {};
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const thisWeekStart = new Date(today);
  thisWeekStart.setDate(thisWeekStart.getDate() - 7);

  conversations.forEach((conv, index) => {
    const convDate = new Date(conv.created_at);
    const convDateOnly = new Date(convDate.getFullYear(), convDate.getMonth(), convDate.getDate());

    if (convDateOnly.getTime() === today.getTime()) {
      if (!grouped['TODAY']) {
        grouped['TODAY'] = {}
        grouped['TODAY']['data'] = [];
        grouped['TODAY']['order'] = 1;
      }
      grouped['TODAY']['data'].push(conv);
    } else if (convDateOnly.getTime() === yesterday.getTime()) {
      if (!grouped['YESTERDAY']) {
        grouped['YESTERDAY'] = {}
        grouped['YESTERDAY']['data'] = [];
        grouped['YESTERDAY']['order'] = 2;
      }
      grouped['YESTERDAY']['data'].push(conv);
    } else if (convDate >= thisWeekStart) {
      if (!grouped['THIS WEEK']) {
        grouped['THIS WEEK'] = {}
        grouped['THIS WEEK']['data'] = [];
        grouped['THIS WEEK']['order'] = 3;
      }
      grouped['THIS WEEK']['data'].push(conv);
    } else {
      if (!grouped['OLDER']) {
        grouped['OLDER'] = {}
        grouped['OLDER']['data'] = [];
        grouped['OLDER']['order'] = 4;
      }
      grouped['OLDER']['data'].push(conv);
    }
  });
  return grouped;
};
const groupedChats = groupConversationsByDate(chatList);

  const filteredChats = Object.entries(groupedChats)
    .flatMap(([group, { data }]) => {
      const filteredData = Array.isArray(data)
        ? data.filter(
          (chat) =>
            chat.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : [];

      // Return the group and its filtered chats
      return filteredData.length > 0 ? [[group, filteredData]] : [];
    });

  const DocumentDrawer = ({ isOpen, onClose, documents }) => (
    <motion.div

      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        width: '50%',
        fontSize: '0.85rem',
        height: '100%',
        backgroundColor: '#fff',
        boxShadow: '-2px 0 5px rgba(0,0,0,0.1)',
        zIndex: 1000,
        overflowY: 'auto',
      }}
    >
      <div style={{ padding: '1rem', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between' }}>
        <SubSectionTitle>Documents</SubSectionTitle>
        <Button onClick={onClose} >Close</Button>
      </div>
      <div style={{ padding: '1rem' }}>
        {documentList.length > 0 ? (
          <Table>
            <thead>
              <tr>
                <TableHeader>Name</TableHeader>
                <TableHeader>Size</TableHeader>
                <TableHeader>Masked</TableHeader>
                <TableHeader>Confidence</TableHeader>
                <TableHeader>Status</TableHeader>
              </tr>
            </thead>
            <tbody>
              {documentList.map((doc, index) => (
                <TableRow key={index}>
                  <TableCell>{doc.file_name}</TableCell>
                  <TableCell>{formatBytes(doc.file_size)}</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>{doc.pii_masked === true ? (<FontAwesomeIcon icon={faCheck} />) : (<FontAwesomeIcon icon={faTimes} />)}</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>{doc.classification_confidence == null ? ("-") : (doc.classification_confidence)}
                  </TableCell>
                  <TableCell>
                    <StatusBadge status={'inf0'}>
                      {doc.processing_status.charAt(0).toUpperCase() + doc.processing_status.slice(1)}
                    </StatusBadge>
                  </TableCell>
                </TableRow>
              ))}
            </tbody>


          </Table>
        ) : (
          <p>No documents available.</p>
        )}
      </div>
    </motion.div>
  );

  const goBack = useGoBack();


  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={fadeIn}
      style={{ height: "100%" }}
    >


      <FlexLayout>
        <Flex2ThirdLayout>
          {chatMode === null && (
            <>
              {/* Back Navigation Header */}
              <div style={{
                width: '100%',
                background: '#FFFFFF',
                borderBottom: '1px solid #E5E7EB',
                padding: '12px 32px',
                flexShrink: 0
              }}>
                <div style={{
                  maxWidth: '900px',
                  margin: '0 auto',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <span style={{
                    fontSize: '13px',
                    color: '#3B82F6',
                    cursor: 'pointer',
                    fontWeight: 500
                  }} onClick={goBack}>
                    Knowledge Base
                  </span>
                  <span style={{ color: '#CBD5E1', fontSize: '13px' }}>/</span>
                  <span style={{
                    fontSize: '13px',
                    fontWeight: 600,
                    color: '#1F2937'
                  }}>
                    {(knowledgeBaseDetail?.name && knowledgeBaseDetail?.name.length > 40)
                      ? knowledgeBaseDetail?.name.substring(0, 39) + "..."
                      : knowledgeBaseDetail?.name || 'Document Intelligence KB'}
                  </span>
                </div>
              </div>

              <div style={{ minHeight: "calc(100dvh - 290px)", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", width: '100%', padding: '40px 20px' }}>
                {/* KB Stats Header */}
                <div style={{
                  marginBottom: '32px',
                  textAlign: 'center'
                }}>
                  <h2 style={{
                    fontSize: '20px',
                    fontWeight: 600,
                    color: '#1E293B',
                    marginBottom: '8px'
                  }}>
                    {knowledgeBaseDetail?.name || 'Document Intelligence Knowledge Base'}
                  </h2>
                  <div style={{
                    display: 'flex',
                    gap: '16px',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                    {/* Entities */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '8px 12px',
                      background: '#F8FAFC',
                      border: '1px solid #E2E8F0',
                      borderRadius: '8px'
                    }}>
                      <div style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#EFF6FF',
                        border: '1px solid #DBEAFE'
                      }}>
                        <FontAwesomeIcon icon={faHexagonNodes} style={{ fontSize: '12px', color: '#3B82F6' }} />
                      </div>
                      <span style={{
                        fontSize: '14px',
                        color: '#64748B',
                        fontWeight: 500
                      }}>
                        {knowledgeBaseDetail?.entities?.length ?? 0} entities
                      </span>
                    </div>

                    {/* Documents */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '8px 12px',
                      background: '#F8FAFC',
                      border: '1px solid #E2E8F0',
                      borderRadius: '8px'
                    }}>
                      <div style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#EFF6FF',
                        border: '1px solid #DBEAFE'
                      }}>
                        <FontAwesomeIcon icon={faFileInvoice} style={{ fontSize: '12px', color: '#3B82F6' }} />
                      </div>
                      <span style={{
                        fontSize: '14px',
                        color: '#64748B',
                        fontWeight: 500
                      }}>
                        {uploadedFiles?.length ?? 0} documents
                      </span>
                    </div>
                  </div>
                </div>

                {/* Input Area */}
                <div style={{
                  width: '100%',
                  maxWidth: '700px',
                  background: '#FFFFFF',
                  border: '1px solid #E2E8F0',
                  borderRadius: '12px',
                  padding: '12px 16px',
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {/* Mode Selector Dropdown Pill */}
                    <div
                      onClick={() => {
                        const modes = ['query', 'search', 'report', 'automate'];
                        const currentIndex = modes.indexOf(queryContext);
                        const nextIndex = (currentIndex + 1) % modes.length;
                        setQueryContext(modes[nextIndex]);
                      }}
                      style={{
                        background: '#EFF6FF',
                        border: '1px solid #2563EB',
                        borderRadius: '20px',
                        padding: '6px 12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: 500,
                        color: '#2563EB',
                        whiteSpace: 'nowrap',
                        transition: 'all 150ms ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#DBEAFE';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#EFF6FF';
                      }}
                    >
                      <FontAwesomeIcon 
                        icon={queryContext === 'query' ? faGlobe : queryContext === 'search' ? faSearch : queryContext === 'report' ? faBarChart : faGlobe} 
                        style={{ fontSize: '12px' }} 
                      />
                      <span>
                        {queryContext === 'query' ? 'Query' : queryContext === 'search' ? 'Search' : queryContext === 'report' ? 'Report' : 'Automate'}
                      </span>
                      <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '10px', transform: 'rotate(-90deg)' }} />
                    </div>

                    {/* Text Input */}
                    <textarea
                      ref={textareaRef}
                      value={transcribedText || ''}
                      onChange={(e) => {
                        setTranscribedText(e.target.value);
                        adjustTextareaHeight(e.target);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                          e.preventDefault();
                          if (uploadedFileDetails.length > 0) {
                            handleIngestFiles();
                          } else if (transcribedText.trim()) {
                            handleSubmitQuery();
                          }
                        }
                      }}
                      style={{ 
                        flex: 1,
                        border: 'none',
                        outline: 'none',
                        resize: 'none',
                        fontSize: '14px',
                        fontFamily: 'inherit',
                        color: '#1E293B',
                        background: 'transparent',
                        minHeight: '24px',
                        maxHeight: '120px',
                        overflow: 'auto',
                        lineHeight: '1.5'
                      }}
                      placeholder={queryContext === 'query' ? 'Ask me anything about your documents...' : queryContext === 'search' ? 'Search for specific information...' : queryContext === 'report' ? 'Generate a report about...' : 'Automate a task...'}
                      rows={1}
                    />

                    {/* Action Icons */}
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      {/* Upload Button */}
                      <div {...getRootProps()} style={{ position: 'relative' }}>
                        <input {...getInputProps()} />
                        <div
                          style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            background: '#F8FAFC',
                            border: '1px solid #E2E8F0',
                            transition: 'all 150ms ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#EFF6FF';
                            e.currentTarget.style.borderColor = '#3B82F6';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = '#F8FAFC';
                            e.currentTarget.style.borderColor = '#E2E8F0';
                          }}
                          title="Upload document"
                        >
                          <FontAwesomeIcon icon={faPlus} style={{ fontSize: '14px', color: '#64748B' }} />
                        </div>
                        {uploadedFileDetails.length > 0 && (
                          <span style={{
                            position: 'absolute',
                            top: '-4px',
                            right: '-4px',
                            background: '#3B82F6',
                            color: 'white',
                            borderRadius: '10px',
                            fontSize: '9px',
                            padding: '2px 5px',
                            fontWeight: 600,
                            lineHeight: 1,
                            minWidth: '16px',
                            textAlign: 'center'
                          }}>{uploadedFileDetails.length}</span>
                        )}
                      </div>

                      {/* Voice Button */}
                      <div
                        onClick={handleVoiceRecording}
                        style={{
                          width: '32px',
                          height: '32px',
                          borderRadius: '6px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          background: '#F8FAFC',
                          border: '1px solid #E2E8F0',
                          transition: 'all 150ms ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#EFF6FF';
                          e.currentTarget.style.borderColor = '#3B82F6';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = '#F8FAFC';
                          e.currentTarget.style.borderColor = '#E2E8F0';
                        }}
                        title="Voice input"
                      >
                        <FontAwesomeIcon icon={faHeadset} style={{ fontSize: '14px', color: '#64748B' }} />
                      </div>

                      {/* Send Button */}
                      <div
                        onClick={() => {
                          if (uploadedFileDetails.length > 0) {
                            handleIngestFiles();
                          } else if (transcribedText.trim()) {
                            handleSubmitQuery();
                          }
                        }}
                        style={{
                          width: '32px',
                          height: '32px',
                          borderRadius: '6px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: transcribedText.trim() || uploadedFileDetails.length > 0 ? 'pointer' : 'not-allowed',
                          background: transcribedText.trim() || uploadedFileDetails.length > 0 ? '#3B82F6' : '#F8FAFC',
                          border: transcribedText.trim() || uploadedFileDetails.length > 0 ? '1px solid #3B82F6' : '1px solid #E2E8F0',
                          transition: 'all 150ms ease',
                          opacity: transcribedText.trim() || uploadedFileDetails.length > 0 ? 1 : 0.5
                        }}
                        onMouseEnter={(e) => {
                          if (transcribedText.trim() || uploadedFileDetails.length > 0) {
                            e.currentTarget.style.background = '#2563EB';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (transcribedText.trim() || uploadedFileDetails.length > 0) {
                            e.currentTarget.style.background = '#3B82F6';
                          }
                        }}
                        title="Send"
                      >
                        <FontAwesomeIcon icon={faPaperPlane} style={{ fontSize: '14px', color: transcribedText.trim() || uploadedFileDetails.length > 0 ? '#FFFFFF' : '#CBD5E1' }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {chatMode === 'chat' && (
            <>
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                height: 'calc(100vh - 80px)', 
                overflow: 'hidden'
              }}>
                {/* Chat Window Header */}
                <div style={{
                  width: '100%',
                  background: '#FFFFFF',
                  borderBottom: '1px solid #E5E7EB',
                  padding: '12px 32px',
                  flexShrink: 0
                }}>
                  <div style={{
                    maxWidth: '900px',
                    margin: '0 auto',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    {/* KB Name with Breadcrumb */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{
                        fontSize: '13px',
                        color: '#3B82F6',
                        cursor: 'pointer',
                        fontWeight: 500
                      }} onClick={goBack}>
                        Knowledge Base
                      </span>
                      <span style={{ color: '#CBD5E1', fontSize: '13px' }}>/</span>
                      <span style={{
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#1F2937'
                      }}>
                        {(knowledgeBaseDetail?.name && knowledgeBaseDetail?.name.length > 40)
                          ? knowledgeBaseDetail?.name.substring(0, 39) + "..."
                          : knowledgeBaseDetail?.name || 'Document Intelligence KB'}
                      </span>
                    </div>
                    
                    {/* Action Icons */}
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      {/* Edit Icon */}
                      <div style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        background: '#F8FAFC',
                        border: '1px solid #E2E8F0',
                        transition: 'all 150ms ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#EFF6FF';
                        e.currentTarget.style.borderColor = '#3B82F6';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#F8FAFC';
                        e.currentTarget.style.borderColor = '#E2E8F0';
                      }}
                      onClick={() => { setSelectedChat(null); setChatMode(null) }}
                      title="New Chat">
                        <FontAwesomeIcon icon={faEdit} style={{ fontSize: '14px', color: '#64748B' }} />
                      </div>
                      
                      {/* Documents Icon */}
                      <div style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        background: '#F8FAFC',
                        border: '1px solid #E2E8F0',
                        transition: 'all 150ms ease',
                        position: 'relative'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#EFF6FF';
                        e.currentTarget.style.borderColor = '#3B82F6';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#F8FAFC';
                        e.currentTarget.style.borderColor = '#E2E8F0';
                      }}
                      onClick={() => {
                        setIsDrawerOpen(true);
                        fetchDocumentList();
                      }}
                      title="Documents">
                        <FontAwesomeIcon icon={faFileInvoice} style={{ fontSize: '14px', color: '#64748B' }} />
                        {uploadedFiles?.length > 0 && (
                          <span style={{
                            position: 'absolute',
                            top: '-4px',
                            right: '-4px',
                            background: '#3B82F6',
                            color: 'white',
                            borderRadius: '10px',
                            fontSize: '9px',
                            padding: '2px 5px',
                            fontWeight: 600,
                            lineHeight: 1,
                            minWidth: '16px',
                            textAlign: 'center'
                          }}>
                            {uploadedFiles.length}
                          </span>
                        )}
                      </div>
                      
                      {/* Entities Icon */}
                      <div style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        background: '#F8FAFC',
                        border: '1px solid #E2E8F0',
                        transition: 'all 150ms ease',
                        position: 'relative'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#EFF6FF';
                        e.currentTarget.style.borderColor = '#3B82F6';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#F8FAFC';
                        e.currentTarget.style.borderColor = '#E2E8F0';
                      }}
                      title="Entities">
                        <FontAwesomeIcon icon={faHexagonNodes} style={{ fontSize: '14px', color: '#64748B' }} />
                        {knowledgeBaseDetail?.entities?.length > 0 && (
                          <span style={{
                            position: 'absolute',
                            top: '-4px',
                            right: '-4px',
                            background: '#3B82F6',
                            color: 'white',
                            borderRadius: '10px',
                            fontSize: '9px',
                            padding: '2px 5px',
                            fontWeight: 600,
                            lineHeight: 1,
                            minWidth: '16px',
                            textAlign: 'center'
                          }}>
                            {knowledgeBaseDetail.entities.length}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ 
                  width: '100%', 
                  flex: 1,
                  display: 'flex', 
                  flexDirection: 'column',
                  maxWidth: '900px',
                  margin: '0 auto',
                  minHeight: 0,
                  background: '#FAFBFC'
                }}>
                  {/* Chat Messages */}
                  <div style={{ 
                    flex: 1, 
                    overflowY: 'auto', 
                    padding: '24px 32px',
                    minHeight: 0
                  }} ref={chatContainerRef}>
                  {messageList?.map((conv, index) => (
                    <div key={index} style={{
                      marginBottom: '40px'
                    }}>
                      {conv.from === 'agent' ? (
                        <>
                          {/* Agent Message - Markdown card with table support */}
                          <div style={{ maxWidth: '100%' }}>
                            <MarkdownContainer
                              style={{
                                marginBottom: '0.5rem',
                                minHeight: 'auto',
                                maxHeight: 'none',
                                overflowY: 'initial',
                                height: 'auto',
                              }}
                            >
                              <div className="markdown-content">
                                <ReactMarkdown
                                  remarkPlugins={[remarkGfm]}
                                  components={{
                                    table: ({ node, ...props }) => (
                                      <div style={{ overflowX: 'auto' }}>
                                        <table {...props} />
                                      </div>
                                    ),
                                  }}
                                >
                                  {conv.message}
                                </ReactMarkdown>
                              </div>
                            </MarkdownContainer>
                            <div
                              style={{
                                fontSize: '12px',
                                color: '#9CA3AF',
                                marginTop: '2px',
                              }}
                            >
                              {chatDateFormat(conv.created_at)}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          {/* User Message - Minimal Clean Style */}
                          <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginBottom: '10px'
                          }}>
                            <div style={{ maxWidth: '85%' }}>
                              <div
                                className="kb-markdown"
                                style={{
                                  background: '#3B82F6',
                                  borderRadius: '12px',
                                  padding: '14px 20px',
                                  fontSize: '15px',
                                  lineHeight: '1.6',
                                  color: '#FFFFFF',
                                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                                }}
                              >
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>{conv.message}</ReactMarkdown>
                              </div>
                            </div>
                          </div>
                          <div style={{
                            fontSize: '12px',
                            color: '#9CA3AF',
                            textAlign: 'right'
                          }}>
                            {chatDateFormat(conv.created_at)}
                          </div>
                        </>
                      )}
                    </div>
                  ))}

                  {/* Typing Loader - Minimal Style */}
                  {isTyping && (
                    <div style={{
                      marginBottom: '40px'
                    }}>
                      <div className="typing-loader">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  )}

                  </div>

                  {/* Input Area - Refined Design */}
                  <div style={{
                    width: '100%',
                    background: '#FFFFFF',
                    borderTop: '1px solid #E2E8F0',
                    padding: '12px 32px 8px 32px',
                    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.04)'
                  }}>
                    <div style={{ 
                      maxWidth: '800px', 
                      margin: '0 auto',
                      background: '#F8FAFC',
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      padding: '12px 16px'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      {/* Mode Selector Dropdown Pill */}
                      <div
                        onClick={() => {
                          const modes = ['query', 'search', 'report', 'automate'];
                          const currentIndex = modes.indexOf(queryContext);
                          const nextIndex = (currentIndex + 1) % modes.length;
                          setQueryContext(modes[nextIndex]);
                        }}
                        style={{
                          background: '#EFF6FF',
                          border: '1px solid #2563EB',
                          borderRadius: '20px',
                          padding: '6px 12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          cursor: 'pointer',
                          fontSize: '13px',
                          fontWeight: 500,
                          color: '#2563EB',
                          whiteSpace: 'nowrap',
                          transition: 'all 150ms ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#DBEAFE';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = '#EFF6FF';
                        }}
                      >
                        <FontAwesomeIcon 
                          icon={queryContext === 'query' ? faGlobe : queryContext === 'search' ? faSearch : queryContext === 'report' ? faBarChart : faGlobe} 
                          style={{ fontSize: '12px' }} 
                        />
                        <span>
                          {queryContext === 'query' ? 'Query' : queryContext === 'search' ? 'Search' : queryContext === 'report' ? 'Report' : 'Automate'}
                        </span>
                        <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '10px', transform: 'rotate(-90deg)' }} />
                      </div>

                      {/* Text Input */}
                      <textarea
                        ref={textareaRef2}
                        value={transcribedText || ''}
                        onChange={(e) => {
                          setTranscribedText(e.target.value);
                          adjustTextareaHeight(e.target);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            if (uploadedFileDetails.length > 0) {
                              handleIngestFiles();
                            } else if (transcribedText.trim()) {
                              handleSubmitQuery();
                            }
                          }
                        }}
                        style={{ 
                          flex: 1,
                          border: 'none',
                          outline: 'none',
                          resize: 'none',
                          fontSize: '14px',
                          fontFamily: 'inherit',
                          color: '#1E293B',
                          background: 'transparent',
                          minHeight: '24px',
                          maxHeight: '120px',
                          overflow: 'auto',
                          lineHeight: '1.5'
                        }}
                        placeholder={queryContext === 'query' ? 'Ask me anything about your documents...' : queryContext === 'search' ? 'Search for specific information...' : queryContext === 'report' ? 'Generate a report about...' : 'Automate a task...'}
                        rows={1}
                      />

                      {/* Action Icons */}
                      <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        {/* Upload Button */}
                        <div {...getRootProps()} style={{ position: 'relative' }}>
                          <input {...getInputProps()} />
                          <button
                            style={{
                              background: 'transparent',
                              border: 'none',
                              color: '#475569',
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                              transition: 'all 150ms ease'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = '#F1F5F9';
                              e.currentTarget.style.color = '#2563EB';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = 'transparent';
                              e.currentTarget.style.color = '#475569';
                            }}
                            title="Upload document"
                          >
                            <FontAwesomeIcon icon={faPlus} style={{ fontSize: '14px' }} />
                          </button>
                          {uploadedFileDetails.length > 0 && (
                            <span style={{
                              position: 'absolute',
                              top: '-2px',
                              right: '-2px',
                              background: '#2563EB',
                              color: 'white',
                              borderRadius: '50%',
                              fontSize: '10px',
                              width: '16px',
                              height: '16px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 600
                            }}>{uploadedFileDetails.length}</span>
                          )}
                        </div>

                        {/* Voice Button */}
                        <button
                          onClick={handleVoiceRecording}
                          style={{
                            background: 'transparent',
                            border: 'none',
                            color: '#475569',
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 150ms ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#F1F5F9';
                            e.currentTarget.style.color = '#2563EB';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                            e.currentTarget.style.color = '#475569';
                          }}
                          title="Voice input"
                        >
                          <FontAwesomeIcon icon={faHeadset} style={{ fontSize: '14px' }} />
                        </button>

                        {/* Send Button */}
                        <button
                          onClick={() => {
                            if (uploadedFileDetails.length > 0) {
                              handleIngestFiles();
                            } else if (transcribedText.trim()) {
                              handleSubmitQuery();
                            }
                          }}
                          disabled={!transcribedText.trim() && uploadedFileDetails.length === 0}
                          style={{
                            background: transcribedText.trim() || uploadedFileDetails.length > 0 ? '#2563EB' : 'transparent',
                            border: 'none',
                            color: transcribedText.trim() || uploadedFileDetails.length > 0 ? 'white' : '#CBD5E1',
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: transcribedText.trim() || uploadedFileDetails.length > 0 ? 'pointer' : 'not-allowed',
                            transition: 'all 150ms ease'
                          }}
                          onMouseEnter={(e) => {
                            if (transcribedText.trim() || uploadedFileDetails.length > 0) {
                              e.currentTarget.style.background = '#1D4ED8';
                              e.currentTarget.style.transform = 'scale(1.05)';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (transcribedText.trim() || uploadedFileDetails.length > 0) {
                              e.currentTarget.style.background = '#2563EB';
                              e.currentTarget.style.transform = 'scale(1)';
                            }
                          }}
                          title="Send"
                        >
                          <FontAwesomeIcon icon={faPaperPlane} style={{ fontSize: '14px' }} />
                        </button>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

        </Flex2ThirdLayout>

        {sideBarCollapsed === true && chatList.length > 0 ? (
          <>
            <SubSectionTitle style={{ lineHeight: '40px', display: "flex", justifyContent: "space-between", alignItems: 'center', position: "absolute", top: '0px', right: '0px' }} >
              <FontAwesomeIcon onClick={goBack} icon={faChevronLeft} style={{ fontSize: "20px", padding: "0px 15px", cursor: "pointer" }} />
              {(knowledgeBaseDetail?.name && knowledgeBaseDetail?.name.length > 25) ? (
                knowledgeBaseDetail?.name.substring(0, 24) + "..."
              ) : (
                knowledgeBaseDetail?.name
              )}
              <div>
                {/* <FontAwesomeIcon
                  icon={faSearch}
                  style={{ fontSize: "20px", padding: "0px 15px", cursor: "pointer" }}
                  onClick={() => setIsModalOpen(true)}
                /> */}
                <FontAwesomeIcon
                  icon={faEdit}
                  style={{ fontSize: "20px", padding: "0px 15px", cursor: "pointer" }}
                  onClick={() => { setSelectedChat(null); setChatMode(null) }}
                />
                <FontAwesomeIcon icon={faTableColumns} style={{ fontSize: "20px", padding: "0px 15px", cursor: "pointer" }}
                  onClick={() => setSideBarCollapsed(!sideBarCollapsed)} />
              </div>
            </SubSectionTitle>
          </>
        ) : !sideBarCollapsed && chatList.length > 0 ? (
          <Flex1ThirdLayout
            as={motion.div}
            initial={{ x: 0 }}
            animate={{ x: sideBarCollapsed ? '100%' : '0%' }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              width: '33.33%',
              borderLeft: '1px solid #E5E7EB',
              backgroundColor: '#FFFFFF',
              display: sideBarCollapsed ? 'none' : 'flex',
              flexDirection: 'column',
              transition: 'display 0.3s ease-in-out',
            }}
          >
            {/* Conversation History Header */}
            <div style={{
              padding: '16px 20px',
              borderBottom: '1px solid #E5E7EB',
              background: '#FAFBFC',
              flexShrink: 0
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '12px'
              }}>
                <h3 style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  color: '#1F2937',
                  margin: 0
                }}>
                  Conversation History
                </h3>
                
                {/* Collapse Icon */}
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  background: '#F8FAFC',
                  border: '1px solid #E2E8F0',
                  transition: 'all 150ms ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#EFF6FF';
                  e.currentTarget.style.borderColor = '#3B82F6';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#F8FAFC';
                  e.currentTarget.style.borderColor = '#E2E8F0';
                }}
                onClick={() => setSideBarCollapsed(!sideBarCollapsed)}
                title="Collapse history">
                  <FontAwesomeIcon icon={faTableColumns} style={{ fontSize: '14px', color: '#64748B' }} />
                </div>
              </div>
              
              {/* Stats */}
              <div style={{
                display: 'flex',
                gap: '16px',
                fontSize: '12px',
                color: '#64748B'
              }}>
                <div>
                  <span style={{ fontWeight: 500 }}>Last conversed:</span>{' '}
                  <span style={{ color: '#1F2937' }}>
                    {chatList.length > 0 
                      ? new Date(Math.max(...chatList.map(c => new Date(c.created_at)))).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
                      : 'Never'}
                  </span>
                </div>
                <div>
                  <span style={{ fontWeight: 500 }}>Total:</span>{' '}
                  <span style={{ color: '#1F2937' }}>{chatList.length}</span>
                </div>
              </div>
            </div>

            {/* Timeline View with Scroller */}
            <div style={{ 
              flex: 1,
              display: 'flex',
              overflow: 'hidden',
              position: 'relative'
            }}>
              {/* Conversations List */}
              <div style={{ 
                flex: 1,
                overflowY: 'auto',
                padding: '16px 16px 16px 20px'
              }}>
              <AnimatePresence>
                {Object.entries(groupedChats)
                  .sort(([, a], [, b]) => a.order - b.order)
                  .map(([group, { data }]) => (
                    <div key={group} style={{ marginBottom: '24px' }}>
                      {/* Sticky Date Group Header */}
                      <div style={{
                        position: 'sticky',
                        top: 0,
                        background: '#F1F5F9',
                        padding: '8px 12px',
                        borderRadius: '6px',
                        marginBottom: '12px',
                        zIndex: 10,
                        fontSize: '11px',
                        fontWeight: 600,
                        color: '#475569',
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase'
                      }}>
                        {group}
                      </div>
                      
                      {/* Conversation Cards */}
                      {data.slice().reverse().map((chat, index) => {
                        const isActive = chat.code === selectedChat?.code;
                        const accentColor = chat.status === 'critical' || chat.status === 'warning' 
                          ? '#F59E0B' 
                          : chat.status === 'resolved' 
                          ? '#10B981' 
                          : isActive 
                          ? '#2563EB' 
                          : '#CBD5E1';
                        
                        return (
                          <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.2 }}
                          >
                            <div
                              onClick={() => handleSelectedChat(chat)}
                              style={{
                                background: isActive ? '#EFF6FF' : '#FFFFFF',
                                border: `1px solid ${isActive ? '#2563EB' : '#E2E8F0'}`,
                                borderRadius: '8px',
                                padding: '12px 16px',
                                marginBottom: '8px',
                                cursor: 'pointer',
                                position: 'relative',
                                overflow: 'hidden',
                                transition: 'all 150ms ease',
                                boxShadow: isActive ? '0 0 0 3px rgba(37, 99, 235, 0.1)' : 'none'
                              }}
                              onMouseEnter={(e) => {
                                if (!isActive) {
                                  e.currentTarget.style.transform = 'scale(1.01)';
                                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.06)';
                                  e.currentTarget.style.borderColor = '#2563EB';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!isActive) {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                  e.currentTarget.style.borderColor = '#E2E8F0';
                                }
                              }}
                            >
                              {/* Left Accent Bar */}
                              <div style={{
                                position: 'absolute',
                                left: 0,
                                top: 0,
                                bottom: 0,
                                width: isActive ? '4px' : '2px',
                                background: accentColor,
                                transition: 'all 150ms ease'
                              }} />
                              
                              {/* Row 1: Title + Timestamp */}
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '8px',
                                gap: '12px'
                              }}>
                                <div style={{
                                  fontSize: '14px',
                                  fontWeight: isActive ? 600 : 500,
                                  color: '#1E293B',
                                  flex: 1,
                                  lineHeight: '1.4'
                                }}>
                                  {chat.title}
                                </div>
                                <div style={{
                                  fontSize: '11px',
                                  color: '#94A3B8',
                                  whiteSpace: 'nowrap',
                                  opacity: 0.7
                                }}>
                                  {chatDateFormat(chat.created_at)}
                                </div>
                              </div>
                              
                              {/* Row 2: Preview Snippet */}
                              <div style={{
                                fontSize: '12px',
                                color: '#475569',
                                lineHeight: '1.4',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                marginBottom: '8px'
                              }}>
                                {(chat.summary && chat.summary.length > 60)
                                  ? chat.summary.substring(0, 59) + "..."
                                  : chat.summary || 'No summary available'}
                              </div>
                              
                              {/* Row 3: Status Chip */}
                              <div>
                                <span style={{
                                  fontSize: '10px',
                                  padding: '4px 8px',
                                  borderRadius: '6px',
                                  fontWeight: 500,
                                  display: 'inline-block',
                                  background: chat.status === 'critical' || chat.status === 'warning'
                                    ? '#FEF3C7'
                                    : chat.status === 'resolved'
                                    ? '#D1FAE5'
                                    : isActive
                                    ? '#DBEAFE'
                                    : '#F1F5F9',
                                  color: chat.status === 'critical' || chat.status === 'warning'
                                    ? '#F59E0B'
                                    : chat.status === 'resolved'
                                    ? '#10B981'
                                    : isActive
                                    ? '#2563EB'
                                    : '#94A3B8'
                                }}>
                                  {chat.status === 'critical' ? 'Flagged' : 
                                   chat.status === 'warning' ? 'Flagged' : 
                                   chat.status === 'resolved' ? 'Resolved' :
                                   isActive ? 'Active' : 'Draft'}
                                </span>
                              </div>
                            </div>
                          </motion.div>
                        );
                      })}
                    </div>
                  ))}
              </AnimatePresence>
              </div>

              {/* Timeline Scroller on Right */}
              <div style={{
                width: '4px',
                background: '#F1F5F9',
                position: 'relative',
                flexShrink: 0
              }}>
                {Object.entries(groupedChats)
                  .sort(([, a], [, b]) => a.order - b.order)
                  .map(([group], index, arr) => (
                    <div
                      key={group}
                      style={{
                        position: 'absolute',
                        top: `${(index / arr.length) * 100}%`,
                        left: 0,
                        width: '100%',
                        height: `${(1 / arr.length) * 100}%`,
                        background: index === 0 ? '#3B82F6' : index === 1 ? '#60A5FA' : '#93C5FD',
                        cursor: 'pointer',
                        transition: 'all 150ms ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.width = '8px';
                        e.currentTarget.style.left = '-4px';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.width = '4px';
                        e.currentTarget.style.left = '0';
                      }}
                      title={group}
                    />
                  ))}
              </div>
            </div>

          </Flex1ThirdLayout>
        ) : null}
        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h2>Filter Chats</h2>
              <input
                type="text"
                placeholder="Search by name"
                value={searchModalTerm}
                onChange={(e) => setSearchModalTerm(e.target.value)}
                style={{ marginBottom: '1rem', padding: '0.5rem', width: '100%' }}
              />
              <List>
                <List>
                  {filteredChats.map(([group, chats]) => (
                    <React.Fragment key={group}>
                      <strong>{group}</strong>
                      {chats.map((chat, index) => (
                        <ListItem
                          key={index}
                          highlighted={chat.code === selectedChat?.code}
                          onClick={() => handleSelectedChat(chat)}
                        >
                          <ListItemContent>
                            <ListItemTitle>{chat.title}</ListItemTitle>
                            <ListItemDescription>
                              {(chat.summary && chat.summary.length > 42)
                                ? chat.summary.substring(0, 41) + "..."
                                : chat.summary}
                            </ListItemDescription>
                          </ListItemContent>
                          <ListItemMeta>
                            <ListItemTime>{chatDateFormat(chat.created_at)}</ListItemTime>
                            <ListItemStatus status={chat.status}>
                              {chat.status === "critical"
                                ? "Critical"
                                : chat.status === "warning"
                                  ? "Warning"
                                  : "Normal"}
                            </ListItemStatus>
                          </ListItemMeta>
                        </ListItem>
                      ))}
                    </React.Fragment>
                  ))}
                </List>
              </List>
              <button
                onClick={() => setIsModalOpen(false)}
                style={{ marginTop: '1rem', padding: '0.5rem 1rem' }}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </FlexLayout>
      {isDrawerOpen && (
        <DocumentDrawer
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          documents={documentList}
        />
      )}

    </motion.div>
  );
};

export default KnowledgeBaseQuery;
